import React, { useEffect, useState } from "react";
import { Row, Col, Spinner, Container, Stack } from "react-bootstrap";
import { NavLink, Outlet } from "react-router-dom";
import { getData } from "../../actions/getdata";
import { get_user } from "../../actions/myuser";
import { connect } from "react-redux";
import Navigation from "../Navigation";
import { FaUsers, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { BsFileEarmarkSpreadsheet } from "react-icons/bs";
import {
  CUSTOMERS_LOADED_SUCCESS,
  TICKETS_LOADED_SUCCESS,
} from "../../actions/types";
import { AiOutlineHome } from "react-icons/ai";
import { PiInvoiceFill } from "react-icons/pi";
import {
  FaMoneyBill1,
  FaMoneyBillTransfer,
  FaMoneyCheckDollar,
} from "react-icons/fa6";
import SmallSideBar from "../ticketing/SmallSideBar";
import { useNavigate } from "react-router-dom";
import {
  LiaFileInvoiceDollarSolid,
  LiaMoneyCheckAltSolid,
} from "react-icons/lia";
import { useDispatch } from "react-redux";
import { GET_TRAVEL_ITEM } from "../../actions/types";
import { AiOutlineUserSwitch } from "react-icons/ai";
import { LiaFileInvoiceSolid } from "react-icons/lia";
import { GrDocumentStore } from "react-icons/gr";
import { TbNotes, TbCreditCardPay, TbTicket } from "react-icons/tb";
import { RiStickyNoteAddLine } from "react-icons/ri";
import { MdOutlineNoteAlt, MdCardTravel } from "react-icons/md";

function FinanceSideBar({ user, get_user }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showSales, setShowSales] = useState(false);
  const [showAudit, setShowAudit] = useState(false);
  const [showPurchases, setShowPurchases] = useState(false);
  const ticketsurl = `${process.env.REACT_APP_API_URL}/ticketing/add_ticket`;
  const customerurl = `${process.env.REACT_APP_API_URL}/finance/create_customer`;
  const travelUrl = `${process.env.REACT_APP_API_URL}/finance/add_travel_item`;
  const [accounts, setAccounts] = useState(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    get_user()
      .then((res) => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  useEffect(() => {
    getData(customerurl)
      .then((res) => {
        dispatch({
          type: CUSTOMERS_LOADED_SUCCESS,
          payload: res,
        });
      })
      .catch((err) => console.log(err));
    getData(ticketsurl)
      .then((res) => {
        dispatch({
          type: TICKETS_LOADED_SUCCESS,
          payload: res.tickets,
        });
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    getData(travelUrl)
      .then((res) => {
        console.log(res);
        dispatch({ type: GET_TRAVEL_ITEM, payload: res });
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return loading ? (
    <Container fluid>
      <Row className="maincontainer">
        <Col className="loader d-flex justify-content-center align-items-center flex-column">
          <Spinner animation="border" variant="dark" />
        </Col>
      </Row>
    </Container>
  ) : (
    user.role === "finance" && (
      <Container fluid className="maincontainer">
        <Row>
          <Col lg={12} md={12} sm={12} style={{ height: "5vh" }}>
            <Navigation />
          </Col>
          <Col
            lg={12}
            md={12}
            sm={12}
            style={{ paddingTop: "4vh" }}
            className="mainarea">
            <Row>
              <Col
                lg={2}
                md={2}
                sm={0}
                className="navigationcolumn d-none d-lg-block d-md-block">
                <nav style={{ position: "relative", paddingTop: "0vh" }}>
                  <div
                    style={{
                      top: "0vh",
                      borderBottom: "1px solid #ccc",
                    }}>
                    <Stack
                      direction="horizontal"
                      className="d-flex justify-content-center">
                      <div
                        style={{ cursor: "pointer" }}
                        className={
                          accounts
                            ? "bg-light text-dark p-3"
                            : "bg-dark text-light p-3"
                        }
                        onClick={() => {
                          navigate("/finance/home");
                          setAccounts(false);
                        }}>
                        <span className="single-line">
                          <span
                            className={`arrowleft ${!accounts ? "open" : ""}`}>
                            &#9664;
                          </span>
                          {"  "} General
                        </span>
                      </div>

                      <div
                        style={{ cursor: "pointer" }}
                        className={
                          accounts
                            ? "bg-dark text-light p-3"
                            : "text-dark bg-light p-3"
                        }
                        onClick={() => {
                          navigate("/finance/home");
                          setAccounts(true);
                        }}>
                        <span className="single-line">
                          Reports{" "}
                          <span
                            className={`arrowright ${accounts ? "open" : ""}`}>
                            &#9654;
                          </span>
                        </span>
                      </div>
                    </Stack>
                  </div>
                  <NavLink to="/finance/home" className="navanchor">
                    <AiOutlineHome className="icon" />
                    Dashboard
                  </NavLink>
                  {accounts ? (
                    <>
                      <NavLink to={"/finance/ledgers"} className="navanchor">
                        <LiaFileInvoiceDollarSolid className="icon" />
                        Ledgers
                      </NavLink>
                      <div className="navgroup">
                        <div
                          className={`navgroup-title ${
                            showSales ? "open" : ""
                          }`}
                          onClick={() => {
                            setShowAudit((a) => !a);
                          }}>
                          <LiaMoneyCheckAltSolid className="icon" />
                          Sales Audit
                          <span className={`arrow ${showAudit ? "open" : ""}`}>
                            &#9654;
                          </span>
                        </div>
                      </div>
                      {showAudit && (
                        <div className="navgroup-items">
                          <NavLink to="/finance/audit" className="navanchor">
                            <GrDocumentStore className="icon" />
                            Consultants
                          </NavLink>
                        </div>
                      )}
                      <NavLink
                        to={"/finance/bank_reconciliation"}
                        className="navanchor">
                        <LiaFileInvoiceDollarSolid className="icon" />
                        Bank Reconciliation
                      </NavLink>
                      <NavLink
                        to={"/finance/balance_sheet"}
                        className="navanchor">
                        <BsFileEarmarkSpreadsheet className="icon" />
                        Balance Sheet
                      </NavLink>
                      <NavLink
                        to="/finance/income_statement"
                        className="navanchor">
                        <PiInvoiceFill className="icon" />
                        Income Statement
                      </NavLink>
                    </>
                  ) : (
                    <>
                      <NavLink to={"/finance/sales"} className="navanchor">
                        <TbTicket className="icon" />
                        Ticket Sales
                      </NavLink>

                      <NavLink
                        to="/finance/travelitem"
                        className="navanchordrop navanchor">
                        <MdCardTravel className="icon" />
                        Travel Items
                      </NavLink>

                      {/* Sales Group */}
                      <div className="navgroup">
                        <div
                          className={`navgroup-title ${
                            showSales ? "open" : ""
                          }`}
                          onClick={() => {
                            setShowSales(!showSales);
                            if (showPurchases) {
                              setShowPurchases(false);
                            }
                          }}>
                          <LiaMoneyCheckAltSolid className="icon" />
                          Billing & Credit
                          <span className={`arrow ${showSales ? "open" : ""}`}>
                            &#9654;
                          </span>
                        </div>
                        {showSales && (
                          <div className="navgroup-items">
                            <NavLink
                              to="/finance/newquotation"
                              className="navanchordrop navanchor">
                              <LiaFileInvoiceSolid className="icon" />
                              Quotations
                            </NavLink>
                            <NavLink
                              to="/finance/proforma"
                              className="navanchor">
                              <PiInvoiceFill className="icon" />
                              Proformas
                            </NavLink>
                            <NavLink
                              to={"/finance/invoices"}
                              className="navanchor">
                              <LiaFileInvoiceDollarSolid className="icon" />
                              Invoices
                            </NavLink>
                            <NavLink
                              to={"/finance/debit-notes"}
                              className="navanchor">
                              <RiStickyNoteAddLine className="icon" />
                              Debit Notes
                            </NavLink>
                            <NavLink
                              to={"/finance/credit_notes"}
                              className="navanchor">
                              <TbNotes className="icon" />
                              Credit Notes
                            </NavLink>
                          </div>
                        )}
                      </div>

                      {/* Purchases Group */}
                      <div className="navgroup">
                        <div
                          className={`navgroup-title ${
                            showPurchases ? "open" : ""
                          }`}
                          onClick={() => {
                            setShowPurchases(!showPurchases);
                            if (showSales) {
                              setShowSales(false);
                            }
                          }}>
                          <FaMoneyBillTransfer className="icon" />
                          Bills & Expenses
                          <span
                            className={`arrow ${showPurchases ? "open" : ""}`}>
                            &#9654;
                          </span>
                        </div>
                        {showPurchases && (
                          <div className="navgroup-items">
                            <NavLink to="/finance/bills" className="navanchor">
                              <FaMoneyCheckDollar className="icon" />
                              Bills
                            </NavLink>
                            <NavLink
                              to="/finance/expenses"
                              className="navanchor">
                              <FaMoneyBill1 className="icon" />
                              Expenses
                            </NavLink>
                            <NavLink
                              to="/finance/payments"
                              className="navanchor">
                              <TbCreditCardPay className="icon" />
                              Payments
                            </NavLink>
                          </div>
                        )}
                      </div>

                      {/* Customers and Suppliers */}
                      <NavLink to="/finance/customers" className="navanchor">
                        <FaUsers className="icon" />
                        Customers
                      </NavLink>
                      <NavLink to="/finance/suppliers" className="navanchor">
                        <AiOutlineUserSwitch className="icon" />
                        Suppliers
                      </NavLink>
                      <NavLink to="/finance/journals" className="navanchor">
                        <MdOutlineNoteAlt className="icon" />
                        Manual Journals
                      </NavLink>
                    </>
                  )}
                </nav>
              </Col>
              <Col lg={10} md={10} sm={12} className="contentarea">
                <Outlet />
              </Col>
            </Row>
          </Col>
        </Row>
        <SmallSideBar />
      </Container>
    )
  );
}

const mapStateToProps = (state) => ({
  user: state.current_user.user,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, { get_user })(FinanceSideBar);
